import PatientsExternalDirectory from './PatientsExternalDirectory';

export default PatientsExternalDirectory;
